<template>
  <div>
    ส่งของไปจีน
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
